export default recaptchaKey =>
  new Promise(resolve => {
    try {
      // Check if we are using the Enterprise version or the API version
      const isEnterprise = recaptchaKey.includes("enterprise");

      // Load the correct script based on the type of reCAPTCHA
      const scriptSrc = isEnterprise
        ? `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaKey}`
        : `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;

      // Dynamically load the script
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.onload = () => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(recaptchaKey, {
              action: 'submit',
            })
            .then(token => {
              resolve(token || '');
            });
        });
      };

      // Append the script tag to the head
      document.head.appendChild(script);
    } catch (e) {
      resolve('');
    }
  });
